<x-y-graph [chartTitle]="'Incidents shared over time'" [showKey]="true" [chartId]="'incidentsSharedChart'" [widthHeightRatio]="0.37" 
    [graphPair]="graphPair">
    <div class="graph-date-controls" chart-controls>
        <div class="chart-component-header">Shared Incidents</div>
        <date-selector (selectedDateChange)="onDateChange($event)" [selectedDate]="selectedDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </div>
</x-y-graph>
